import { useConnectSolanaWallet } from './useConnectSolanaWallet';
import { useSolanaBalance } from './useSolanaBalance';

export const useSolanaWallet = () => {
  const { address, isConnected, connect, disconnect } = useConnectSolanaWallet();
  const { data: balance = 0n, isLoading: isLoadingBalance } = useSolanaBalance(address, isConnected);

  return {
    address,
    isConnected,
    connect,
    disconnect,
    balance,
    isLoadingBalance,
  };
};
